<template>
  <el-drawer :withHeader="false" :visible.sync="open" direction="rtl" :before-close="handleClose" size="666px">
    <!-- <div class="close">
      收起
    </div> -->
    <div class="drawer-header">
      <div style="padding-top:20px;display: flex;">
        <div class="start-label" />
        <span class="text">查看资产详情</span>
      </div>
    </div>
    <template v-if="canRead">
      <div class="info">
        <div class="triangle"></div>
        <div class="info-conten">
          <span style="font-size:14px;font-weight:bold">当前资产归属类型:
          </span>
          <span style="margin-left:10px;font-size:14px;color:#E8B23D;font-weight:bold">{{ form.categoryName }}</span><br />
          <span>启用状态：</span>
          <span style="margin-left:10px" :class="{ enable: form.state == 1, forbidden: form.state != 1 }">{{ form.stateName }}</span>
        </div>
      </div>

      <div style="margin-left:20px;margin-top:10px">
        <div class="badge">资产基础信息</div>
        <div style="margin-top:10px">
          <el-form label-width="110px">
            <el-form-item label="资产编号:" prop="no">
              <span class="value">{{ form.no }}</span>
            </el-form-item>
            <el-form-item label="资产名称:" prop="name">
              <span class="value">{{ form.name }}</span>
            </el-form-item>
            <el-form-item label="规格型号:" prop="specName">
              <span class="value">{{ form.specName }}</span>
            </el-form-item>
            <el-form-item label="资产单位:" prop="unitName">
              <span class="value">{{ form.unitName }}</span>
            </el-form-item>
            <el-form-item label="资产品牌:">
              <span class="value">{{ form.brandName }}</span>
            </el-form-item>
            <!-- <el-form-item label="资产单价:">
            <span class="value">{{form.price}}</span>
          </el-form-item> -->
            <el-form-item label="生产厂家:">
              <span class="value">{{ form.manufacturerName }}</span>
            </el-form-item>
            <el-form-item label="供应商:">
              <span class="value">{{ form.supplierName }}</span>
            </el-form-item>
            <el-form-item label="产地类型:">
              <span class="value">{{ form.productionPlaceName }}</span>
            </el-form-item>
            <el-form-item label="注册证号:">
              <span class="value">{{ form.certNo }}</span>
            </el-form-item>
            <el-form-item label="资产类型:">
              <span class="value">{{ form.assetTypeName }}</span>
            </el-form-item>
            <el-form-item label="财务分类:">
              <span class="value">{{ form.financeTypeName }}</span>
            </el-form-item>
            <el-form-item label="关联合同:">
              <span class="value">{{ form.financeTypeName }}</span>
            </el-form-item>
            <el-form-item label="产品来源:">
              <span class="value">{{ form.financeTypeName }}</span>
            </el-form-item>
            <el-form-item label="单价:">
              <span class="value">{{ form.financeTypeName }}</span>
            </el-form-item>
            <el-form-item label="是否效益资产:">
              <span class="value">{{ getBoolName(form.isBenefit) }}</span>
            </el-form-item>
            <el-form-item label="创建时间:">
              <span class="value">{{
                this.parseTime(new Date(form.createdTime))
              }}</span>
            </el-form-item>
            <el-form-item label="更新时间:">
              <span class="value">{{
                this.parseTime(new Date(form.updateTime))
              }}</span>
            </el-form-item>
            <!-- <el-form-item label="维修标志:">
            <span class="value">{{getBoolName(form.isRepairSign)}}</span>
          </el-form-item>
          <el-form-item label="计量标志:">
            <span class="value">{{getBoolName(form.isMeteringSign)}}</span>
          </el-form-item>
          <el-form-item label="是否效益资产:">
            <span class="value">{{getBoolName(form.isBenefit)}}</span>
          </el-form-item>
          <el-form-item label="是否急救资产:">
            <span class="value">{{getBoolName(form.isFirstAid)}}</span>
          </el-form-item>
          <el-form-item label="是否医疗资产:">
            <span class="value">{{getBoolName(form.isMedical)}}</span>
          </el-form-item>
          <el-form-item label="是否特种资产:">
            <span class="value">{{getBoolName(form.isSpecial)}}</span>
          </el-form-item> -->
            <el-form-item label="是否房屋建筑:">
              <span class="value">{{ getBoolName(form.isBuilding) }}</span>
            </el-form-item>
            <el-form-item v-if="form.isBuilding != 1" label="配件:">
              <span class="value">{{ form.parts }}</span>
            </el-form-item>
            <el-form-item v-else label="面积:">
              <span class="value">{{ form.area }} ㎡</span>
            </el-form-item>
            <el-form-item label="创建时间:">
              <span class="value">{{
                this.parseTime(new Date(form.createdTime))
              }}</span>
            </el-form-item>
            <el-form-item label="更新时间:">
              <span class="value">{{
                this.parseTime(new Date(form.updateTime))
              }}</span>
            </el-form-item>
            <el-form-item label="折旧规则:">
              <span class="value">{{ form.depreciationName }}</span>
            </el-form-item>
            <el-form-item label="预计使用寿命:">
              <span class="value">{{ form.serviceLife }} 月</span>
            </el-form-item>
            <el-form-item label="预计净残值率:">
              <span class="value">{{ form.netSalvage }} %</span>
            </el-form-item>
            <el-form-item label="预计总工作量:">
              <span class="value">{{ form.totalWorkload }}</span>
            </el-form-item>
            <el-form-item label="预计资产残值:">
              <span class="value">{{ form.salvage }}</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="check-password-div">
        <div class="check-password-box">
          <label for="">请输入密码进行查看</label>
          <el-input class="check-password-input" v-model="password" placeholder="请填写资产卡看密码" style="width:90%;text-security:disc; -webkit-text-security:disc;"></el-input>
          <el-button class="btn primary width100 check-password-btn" type="primary" size="small" v-preventReClick @click="checkPassword">查看</el-button>
        </div>
      </div>
    </template>
  </el-drawer>
</template>

<script>
import { GetNoneAssetById, IsEnablePassWord, CheckPassword } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";

export default {
  name: "user-info",
  mixins: [GetDataMixin],
  data () {
    return {
      open: false,
      form: {},
      password: "",
      canRead: true,
    };
  },
  props: {
    show: {
      type: Boolean,
      default () {
        return false;
      },
    },
    id: {
      type: Number,
      default () {
        return 0;
      },
    },
  },
  watch: {
    show (val, oldVal) {
      this.open = val;
      this.password = "";
      if (this.open) {
        this.checkNeedPassword();
      }
    },
  },
  methods: {
    handleClose () {
      this.$emit("handleClose");
    },
    checkNeedPassword () {
      IsEnablePassWord({ id: this.id }).then((res) => {
        this.canRead = !res.returnData;
        if (res.returnData) {
          // 需要验证密码
        } else {
          // this.getInfo();
          this.$router.push("/none-asset-edit?formMode=0&id=" + this.id);
        }
      });
    },
    checkPassword () {
      CheckPassword({ id: this.id, password: this.password }).then((res) => {
        this.canRead = res.returnData;
        if (res.returnData) {
          // 验证成功
          // this.getInfo();
          this.$router.push("/none-asset-edit?formMode=0&id=" + this.id);
        } else {
          // 密码错误
          this.$my_message(`密码错误`, "warning");
        }
      });
    },
    getInfo () {
      GetNoneAssetById({ id: this.id }).then((res) => {
        this.resetForm();
        this.form = res.returnData;
      });
    },
    resetForm () {
      this.form = {
        orgCode :sessionStorage.getItem('orgId')
      };
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-form-item__content {
  line-height: 20px !important;
  color: #606166;
  font-weight: 400;
}
/deep/ .el-form-item__label {
  padding-bottom: 0 !important;
  line-height: 20px !important;
}
.el-form-item {
  margin-bottom: 5px !important;
}
.check-password-div {
  height: calc(100% - 78px);
  width: 100%;
  .check-password-box {
    margin: auto;
    margin-top: calc(50% - 80px);
    width: 320px;
    height: 161px;
    label {
      font-size: 14px;
      font-weight: 700;
      line-height: 14px;
      color: #303033;
    }
    .check-password-input {
      margin-top: 20px;
      width: 320px;
      height: 40px;
    }
    .check-password-btn {
      margin-top: 40px;
      width: 320px;
      height: 40px;
    }
  }
}
</style>
